module.exports = __webpack_public_path__ + "static/beluga-89023d1c1c1601989ff6d989cf68336a.png";